import React, { useState } from 'react';
import './LiveTab.css';

const LiveTab = () => {
  // State to store the video ID
  const [videoId, setVideoId] = useState('z1qK6sNtcVA'); // Default video ID (you can change this)
  
  // Video options
  const opts = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
      rel: 0,
      modestbranding: 1,
    },
  };

  return (
    <div className="live-tab-container">
      <h2 className="live-title">Live Transliacija <span className="live-indicator">LIVE</span></h2>
      <div className="video-container">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="youtube-iframe"
        ></iframe>
      </div>
      
      <div className="video-info">
        <h3>Beach Bros Turnyras</h3>
        <p className="video-description">
          Stebėkite mūsų Beach Bros paplūdimio tinklinio turnyrą tiesiogiai!
          Kai nėra tiesioginės transliacijos, žiūrėkite ankstesnių turnyrų vaizdo įrašus.
        </p>
      </div>
    </div>
  );
};

export default LiveTab;